export default "/_next/static/sounds/trim-page-turn-4-e477e6da89f373f257491ea90f7340c7.mp3";